/**
 * OMB Metro–Micro Delineations (CBSA) — county-level lookup.
 * Generated by data_raw/build_cbsa.R from the Census Bureau's July 2023
 * delineation file (OMB Bulletin No. 23-01, 2020 standards + 2020 Census).
 *
 * Value: { status, title, central }
 *   status: 1 = Metropolitan Statistical Area, 2 = Micropolitan Statistical
 *           Area, 0 = noncore (outside any CBSA — derived by complement
 *           against the full county universe, so 0 is explicit, not missing)
 *   title:  CBSA title, e.g. "Montgomery, AL" (metro/micro only)
 *   central: true = central county, false = outlying (metro/micro only)
 *
 * This is the authoritative source of the metro/micro/noncore trichotomy —
 * the upstream of RUCC, UIC, NCHS, and FORHP eligibility. Display/comparison
 * and the OMB Designation badge only — NOT a composite input.
 *
 * Source:  https://www.census.gov/geographies/reference-files/time-series/demo/metro-micro/delineation-files.html
 * License: Public domain (US federal work, 17 U.S.C. § 105)
 */

let _data = null;
let _loadPromise = null;

export function loadCbsaData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/cbsa.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load CBSA data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getCBSAForCounty(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  if (!v || typeof v.s !== "number") return null;
  return {
    status: v.s,
    title: v.t ?? null,
    central: v.c === 1,
  };
}

const CBSA_STATUS_LABELS = {
  0: "Noncore",
  1: "Metropolitan",
  2: "Micropolitan",
};

export function getCBSAStatusLabel(status) {
  if (status == null) return null;
  return CBSA_STATUS_LABELS[status] ?? null;
}

const cbsa = { loadCbsaData, getCBSAForCounty, getCBSAStatusLabel };
export default cbsa;
